import { render, staticRenderFns } from "./ModalImageViewer.vue?vue&type=template&id=05a84f46&scoped=true&"
import script from "./ModalImageViewer.vue?vue&type=script&lang=js&"
export * from "./ModalImageViewer.vue?vue&type=script&lang=js&"
import style0 from "./ModalImageViewer.vue?vue&type=style&index=0&id=05a84f46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a84f46",
  null
  
)

export default component.exports